import { compose } from 'redux';
import { connect } from 'react-redux';
import AvatarView from '../avatar/avatarView';
import withAvatar from '../avatar/withAvatar';
import InterstitialView from './InterstitialView';
import { completeAssessment } from '../start/startActions';

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.HIDDEN,
});

const mapDispatchToProps = (dispatch) => ({
    goToNextPage() {
        dispatch(completeAssessment());
    },
});

const InterstitialContainer = compose(
    connect(null, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(InterstitialView);

export default InterstitialContainer;
